import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

const LastNameComponent = ({ value, isErrored, onChange, placeholder = '' }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-last-name">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-last-name">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="lastName"
                        defaultMessage="Last name"
                    />
                </div>
            </label>
            <input
                className={
                    `sid-text-input sid-text-input--required
                        sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                }
                id="sid-last-name"
                name="sid-last-name"
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                ref={input => setRef('lastName', input)}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidLastName"
                            defaultMessage="Invalid last name"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  LastNameComponent };
